import { useCallback, useEffect, useRef } from 'react';

type ServiceFn = (signal: AbortSignal, ...params: any[]) => Promise<any> | any;

const useApiRequest = (service: ServiceFn) => {
  const abortControllerRef = useRef<AbortController | null>(null);

  const makeApiRequest = useCallback(async (...params: any[]) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      return await service(controller.signal, ...params);
    } catch (error: any) {
      if (error?.name === 'AbortError') {
        return Promise.resolve(undefined);
      }
      throw error;
    }
  }, [service]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return makeApiRequest;
};

export default useApiRequest;
